// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// This file can be replaced during build by using the `fileReplacements` array.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apihost: 'https://drc-fusion-server.revenuedev.org',
  // apihost: '//94.240.200.120:3000',
  accessToken: 'access_token',
  //plat_server: 'http://62.168.166.110:3000',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
